import { useState } from "react";
import { FetchHandler } from "../../Handlers/FetchHandler"
import { useOrganizations } from "../Organizations/useOrganizations";

export const usePlantOrigins = () => {

    const api = usePlantOriginsApi();
    const org = useOrganizations();



    return {
        organizations: org.data,
        organizationsLoad: org.doSearch,
        getApprovedOriginsForPlant: api.getApprovedOriginsForPlant,
        getAllApproved: api.getAllApproved,
        addApproved: api.addApproved,
        updateApproved: api.updateApproved,
        deleteApproved: api.deleteApproved,

    }
}


export const usePlantOriginsApi = () => {

    return {
        getAllApproved: async () => {
            let data: ApprovedPlantOriginModelApiType[] = await FetchHandler.getJson("/api/approvedorigins");
            data.sort((a, b) => {
                if (a.name?.toLowerCase() > b.name?.toLowerCase()) { return 1; }
                else if (a.name?.toLowerCase() < b.name?.toLowerCase()) { return -1; }
                else { return 0; }
            });
            return data;
        },
        addApproved: async (e: ApprovedPlantOriginModelApiType) => {
            const data: ApprovedPlantOriginModelApiType = await FetchHandler.postJson("/api/approvedorigins", e);
            return data;
        },
        updateApproved: async (e: ApprovedPlantOriginModelApiType) => {
            const data: ApprovedPlantOriginModelApiType = await FetchHandler.patchJson("/api/approvedorigins", e);
            return data;
        },
        deleteApproved: async (e: string) => {
            const data: ApprovedPlantOriginModelApiType = await FetchHandler.delete("/api/approvedorigins/" + e);
            return data;
        },
        getApprovedOriginsForPlant: async (plantId: string) => {
            const data: ApprovedOriginsForPlantType = await FetchHandler.getJson("/api/approvedorigins/plant/" + plantId);
            return data;
        },
    }
}


export type ApprovedPlantOriginModelApiType = {
    id?: string
    name?: string
    keywords?: string
    organizationId?: string
}

export type ApprovedOriginsForPlantType = {
    origins: ApprovedOriginsForPlantOriginType[]
    misses: string[]
    totalCount: number
}

export type ApprovedOriginsForPlantOriginType = {
    count: number
    name: string
    keywords: string
    id: string
    imageid: any
    sys_datecreated_utc_epoch: number
    sys_datemodified_utc_epoch: number
}
